(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
function initNewsletterPopups(root=document){
  root.querySelectorAll('[data-newsletter-popup]').forEach(dialog=>{
    if(dialog.dataset.newsletterReady)return;
    dialog.dataset.newsletterReady='true';
    const key='all-human-newsletter-v1';
    const editor=dialog.dataset.editor==='true';
    const result=dialog.querySelector('[data-newsletter-result]');
    let stored={};
    try{stored=JSON.parse(localStorage.getItem(key)||'{}')||{};}catch{}
    const save=value=>{if(editor)return;try{localStorage.setItem(key,JSON.stringify(value));}catch{}};
    const closeUntil=()=>Date.now()+Number(dialog.dataset.days)*86400000;
    const open=()=>{
      if(!dialog.isConnected||dialog.open||document.querySelector('dialog[open]'))return;
      dialog.showModal();document.documentElement.classList.add('dialog-open');
      if(result.dataset.success!=='true')save({until:closeUntil()});
    };
    dialog.addEventListener('close',()=>{
      if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('dialog-open');
      if(result.dataset.success!=='true')save({until:closeUntil()});
    });
    if(result.dataset.success==='true'){save({subscribed:true});open();return;}
    if(result.dataset.errors==='true'){open();return;}
    if(editor)return;
    if(dialog.dataset.customerSubscribed==='true'||stored.subscribed||Number(stored.until)>Date.now())return;
    const timer=setTimeout(open,Number(dialog.dataset.delay)*1000);
    dialog.addEventListener('newsletter:cancel',()=>clearTimeout(timer),{once:true});
  });
}
initNewsletterPopups();
document.addEventListener('shopify:section:load',event=>initNewsletterPopups(event.target));
document.addEventListener('shopify:section:select',event=>{
  const dialog=event.target.querySelector('[data-newsletter-popup]');
  if(dialog&&!dialog.open&&!document.querySelector('dialog[open]')){dialog.showModal();document.documentElement.classList.add('dialog-open');}
});
document.addEventListener('shopify:section:unload',event=>{
  event.target.querySelectorAll('[data-newsletter-popup]').forEach(dialog=>{dialog.dispatchEvent(new Event('newsletter:cancel'));if(dialog.open)dialog.close();});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["random-recommendations"] && !Shopify.designMode) return;
  try {
    
function initRandomRecommendations(root=document){
  root.querySelectorAll('[data-random-recommendations]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const pool=Array.from(section.querySelectorAll('template[data-recommendation-card]'));
    const grid=section.querySelector('[data-recommendation-grid]');
    const count=Math.min(4,pool.length);
    for(let i=0;i<count;i++){
      const choice=i+Math.floor(Math.random()*(pool.length-i));
      [pool[i],pool[choice]]=[pool[choice],pool[i]];
      grid.appendChild(pool[i].content.cloneNode(true));
    }
  });
}
initRandomRecommendations();
document.addEventListener('shopify:section:load',event=>initRandomRecommendations(event.target));

  } catch(e) { console.error(e); }
})();
})();
